import styled from 'styled-components';

export const TodoCreationWrapperStyled = styled.div`
   display: flex;
   align-items: flex-start;
   justify-content: center;
   width: 100%;
   height: 101px;
   margin: 0px 0px 60px 0px;
`;